'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Button = require('@narvar/nth-block-button');
var TextArea = require('@narvar/nth-block-text-area');
var TextLink = require('@narvar/nth-bit-text-link');
var StarRating = require('@narvar/nth-block-star-rating');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Portrait_module = require('./Portrait.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var TextArea__default = /*#__PURE__*/_interopDefaultLegacy(TextArea);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var StarRating__default = /*#__PURE__*/_interopDefaultLegacy(StarRating);

const Portrait = ({
  featureName,
  selectedRating,
  onRatingSelect,
  onClickSupportLink,
  submitFeedback,
  commentOptional
}) => {
  const {
    feedbackButtonText = '',
    feedbackCommentLabel = '',
    feedbackCustomerSupportLink = '',
    feedbackExperienceHeader = ''
  } = nthHookTranslations.useTranslations();
  const {
    linksNoneDefault: textLinkStyle,
    linksNoneHover: textLinkHoverStyle
  } = nthHookTheme.useTheme();
  const {
    feedback
  } = nthHookSettings.useSettings();
  const {
    enableInitialCollapse: initialCollapsed,
    customerSupportLink
  } = feedback || {};
  const [feedbackComment, setFeedbackComment] = React.useState('');
  const [collapsed, setCollapsed] = React.useState(Boolean(initialCollapsed));
  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "feedbackPortraitView"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Portrait_module["default"].portraitHeader
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, {
    featureName: featureName,
    as: "p"
  }, feedbackExperienceHeader)), /*#__PURE__*/React__default["default"].createElement(StarRating__default["default"], {
    onClick: index => {
      onRatingSelect(index);
      setCollapsed(false);
    },
    selectedRating: selectedRating,
    featureName: featureName
  }), !collapsed && /*#__PURE__*/React__default["default"].createElement("div", {
    "data-test": "feedbackPortraitExpandedBlock"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Portrait_module["default"].feedbackBox
  }, /*#__PURE__*/React__default["default"].createElement(TextArea__default["default"], {
    id: "feedbackCommentBox",
    animateLabel: true,
    label: feedbackCommentLabel || '',
    featureName: featureName,
    onChange: event => setFeedbackComment(event.target.value)
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: Portrait_module["default"].feedbackAction
  }, /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    disabled: !commentOptional && !feedbackComment.length,
    big: true,
    featureName: featureName,
    onClick: () => {
      if (submitFeedback) submitFeedback(feedbackComment);
    }
  }, feedbackButtonText)), customerSupportLink && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    target: TextLink.TextLinkTargetType.BLANK,
    href: customerSupportLink,
    linkStyle: {
      sDefault: textLinkStyle,
      sHover: textLinkHoverStyle
    },
    onClick: () => {
      if (onClickSupportLink) onClickSupportLink();
    }
  }, feedbackCustomerSupportLink)));
};
var Portrait$1 = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(Portrait, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['feedbackButtonText', 'feedbackCommentLabel', 'feedbackCustomerSupportLink', 'feedbackExperienceHeader']
}), {
  settingsRequested: `
      feedback {
        enableInitialCollapse
        customerSupportLink
      }
    `
});

exports["default"] = Portrait$1;
